import { ClickAwayListener, IconButton } from "@mui/material";
import React from "react";
import Editor from "../../../../Editor/Editor";
import ExpandMoreIcon from "@mui/icons-material/ExpandMore";
import { createRoot } from "react-dom/client";
import { tokenProcessingTest } from "../../../../TokenProcessing/TokenProcessing";
import DialogSetObjText from "../../../Module/Dialogs/DialogSetObjText";
import DialogCreateObj from "../../../Module/Dialogs/DialogCreateObj";
import { fontFlagsToCss, getStyleWindow, setColor } from "../../../Tools/Tools";
import CheckBoxMultiCheck from "../CheckBoxMultiCheck";
import LoadingMask from "../../../NotWorkArea(Side&Head)/LoadingMask";
import HistoryIcon from "@mui/icons-material/History";
import TextAreaWithButtons from "../../../Module/Dialogs/Components/TextAreaWithButtons";
import DialogHistory from "../../../Module/Dialogs/DialogHistory";
import styles from "./ParamsStyles.module.css";
import clsx from "clsx";
import ConditionButton from "./ParamsComponents/ConditionButton";
import { EditStyle, ParamSetOption, Prefixes } from "../../../Tools/ProjectX";
import smetaAxios from "../../../../SmetaAxios";
import { smetaModals } from "../../../Tools/modalManager";

// функции для сплиттера с возможностью изменения размеров полей
let resize = {};

// функция включения live изменения размеров
function onMouseDown(ev) {
  const record = ev.target.closest("TR");
  const table = record.parentElement;
  const el = record.querySelector(".td-name");
  const elements = table.querySelectorAll(".td-name");
  resize.resizeMode = true;
  resize.target = ev.target;
  resize.cells = elements;
  resize.cell = el;
}
// функция установки размеров после изменения
function onMouseUp(ev, setWidth) {
  if (resize.size !== undefined) {
    if (resize.ctrlKey) {
      resize = {};
      return;
    }
    setWidth(resize.size);
    resize = {};
  }
}

// функция live изменения размеров
function onMouseMove(ev) {
  if (resize.resizeMode) {
    const x = ev.clientX;
    const targetWidth = resize.target.clientWidth;
    const targetX = resize.target.getBoundingClientRect().x;

    if (ev.ctrlKey) {
      resize.ctrlKey = true;
      let size = x - targetWidth - targetX;
      size =
        (resize.cell.clientWidth / resize.cell.parentElement.clientWidth) * 100 +
        (size / resize.cell.parentElement.clientWidth) * 100;
      if (size < 30) size = 30;
      if (size > 70) size = 70;
      resize.size = size;
      resize.cell.style.width = `${size}%`;

      return;
    }
    resize.cells.forEach((el) => {
      let size = x - targetWidth - targetX;
      if (el.style.clientWidth === 0) return;
      size = (el.clientWidth / el.parentElement.clientWidth) * 100 + (size / el.parentElement.clientWidth) * 100;
      if (size < 30) size = 30;
      if (size > 70) size = 70;
      resize.size = size;
      el.style.width = `${size}%`;
    });
  }
}

// функция расчета отступов для параметров в завизимости от уровня вложенности
function getPadding(items, item, index) {
  let padding = 15;
  const level = item.Level ? item.Level : 0;

  if (items.length - 1 > index && level < items[index + 1].Level) {
    padding -= 15;
  }
  if (item.Level) {
    padding += item.Level * 15;
  }
  return padding;
}

// функция для выбора запроса
// возвращает функицю в которую нужно передать data
// пример: getSetParamRequest(selector)({data})
function getSetParamRequest(selector, props) {
  const requests = {
    custom: (data) => {
      return props.onEditCustom({ ...data, parentID: props.ID });
    },

    default: (data) => {
      const params = {
        DocCfgID: props.DocCfgID,
        DocID: data.ID,
        ObjRef: data.ObjRef || "0",
        State: data.CheckState,
        Type: data.Type,
      };
      const config = {
        prefix: Prefixes.doc,
        method: "POST",
        url: "SetDetailValue",
        params,
        data: { Text: data.Value },
      };
      return smetaAxios(config);
    },
  };
  return selector && requests[selector] ? requests[selector] : requests.default;
}

// функция установки стилей для текста названия параметра
function getStyleName(item) {
  return {
    display: "flex",
    flex: "1 1 0",
    color: setColor(item.NameColor),
    ...fontFlagsToCss(item.NameStyle),
  };
}

function getStyleText(item) {
  const style = fontFlagsToCss(item.TextStyle);
  if (item.TextStyle !== undefined) {
    style.fontSize = "0.75rem";
  }
  return style;
}

export default function DetailsParams(props) {
  // полные данные параметров
  const [paramsData, setParamData] = React.useState();
  // данные записей
  const [paramsItems, setParamsItems] = React.useState();
  // записи для отрисовки
  const [paramsJsx, setParamsJsx] = React.useState();

  // размер 1-ой колонки для контроля
  const [width, setWidth] = React.useState(35);

  const [buttonBlockWidth, setbuttonBlockWidth] = React.useState(0);
  // переменная для хранения элемента с редактором
  const editor = React.useRef(undefined);

  // карта с функциями редактирования отрисованных редакторов
  const [editionMap, setEditionMap] = React.useState();

  // хук для получения функций редактирования и записи их в карту выше
  const [getEdition, setGetEdition] = React.useState();

  // костыль для Просмотра проводок
  const inputValue = React.useRef([]);

  // переменная для динамической отрисовки редактора, контролирует отрисвку по нажатой клавише мыши
  const mouseDown = React.useRef(null);

  // ссылка на контейнер параметров
  const paramsBox = React.useRef(undefined);

  const editorVals = React.useRef({});
  const title = paramsData ? paramsData.Title : props.Title || "";

  // Первичная установка объекта параметров
  React.useEffect(() => {
    // получение данных если они не были переданны из вне
    if (props.data) {
      setParamData(props.data);
    }
    setEditionMap(new Map());

    if (props.inputValue) {
      inputValue.current = props.inputValue.split(";");
    }
  }, []);

  // при изменении данных снаружи они обновляются
  React.useEffect(() => {
    if (props.data) {
      setEditionMap(new Map());
      setParamsJsx(null);
      setParamData(props.data);
    }
  }, [props.data]);

  React.useEffect(() => {
    // обновление параметров при изменении общих данных
    if (paramsData) {
      // скрытие текущего редактора если он был открыт
      if (editor.current) {
        deleteEditor(editor.current);
      }
      // обновление массива записей
      setParamsItems(paramsData.Items);
    }
  }, [paramsData]);

  React.useEffect(() => {
    // обновление отрисованных записей
    if (paramsItems) {
      setParamsJsx(getJsxParams(paramsItems, setWidth));
    }
  }, [paramsItems]);

  // заполнение карты с функциями редактирования при отрисовке нового редактора
  React.useEffect(() => {
    if (getEdition) {
      editionMap.set(getEdition.id, {
        setValue: getEdition.setValue,
        setInputValue: getEdition.setInputValue,
        value: getEdition.value,
        inputValue: getEdition.inputValue,
      });
    }
  }, [getEdition]);

  // разворачивание записей при первой отрисовке, если они должны быть развернуты
  React.useLayoutEffect(() => {
    if (paramsJsx) {
      paramsBox.current.querySelectorAll("#expandButtonParams").forEach((el) => {
        if ((Number(el.dataset.collapsed) & ParamSetOption.Collapsed) !== ParamSetOption.Collapsed) {
          el.closest("TR").dataset.collapsed = "1";
          expandRec({ target: el });
        }
      });
    }
  }, [paramsJsx]);

  // функция для получения кнопки разворачивания записей
  function getExpandButton(items, item, index) {
    const level = item.Level ? item.Level : 0;
    if (items.length - 1 > index && level < items[index + 1].Level) {
      return (
        <IconButton
          id="expandButtonParams"
          data-collapsed={item.Options}
          name="expandButton"
          onClick={async (ev) => {
            const record = ev.target.closest("tr");
            await collapseReq(
              record.id.split("_")[1],
              props.Path ? props.Path : paramsData.Path,
              record.dataset.collapsed === "1" ? "0" : "1",
            );
            expandRec(ev);
          }}
          className={clsx(
            styles.paramsExpandButton,
            Number(item.Options) & ParamSetOption.Collapsed && styles.paramsExpandButtonRotate,
          )}
        >
          <ExpandMoreIcon style={{ height: "15px", width: "15px" }} />
        </IconButton>
      );
    }
  }

  // запрос сворачивания и разворачивания записи для сервера
  async function collapseReq(id, Path, collapsed) {
    const params = {
      Path: Path,
      ID: id,
      Collapsed: collapsed,
    };
    const config = {
      prefix: Prefixes.progs,
      method: "GET",
      url: "ParamCollapsed",
      params,
    };
    return smetaAxios(config);
  }

  // Функция скрытия и отображения записей при клике на кнопку expandButton
  function expandRec(ev) {
    // получение кнопки на текущей записи
    let button = ev.target.closest("BUTTON");
    // получение текущей записи
    let record = ev.target.closest("TR");
    const tdName = record.querySelector(".td-name");
    // получение уровня вложенности
    let level = record.dataset.level;
    // получение следующей записи
    let nextRec = record.nextElementSibling;

    //выражение для проверки состояния развернутости записи
    const condition = record.dataset.collapsed === "1";
    // сокрытие или раскрытие всех дочерних записей у родительской
    // цикл работает до тех пор, пока уровень вложенности следующей записи больше чем уровень первоначальной записи
    while (nextRec && nextRec.dataset.level > level) {
      // проверка привязки к родительской записи
      // if (nextRec.dataset.parentid === parentID) {
      // проверка на наличие вложенных записей
      const nextButton = nextRec.querySelector("button[name=expandButton]");
      // если вложенные записи были развернуты то они свернутся при сворачивании записей родителя
      if (nextButton && nextRec.dataset.collapsed === "0") {
        nextRec.dataset.collapsed = "1";
        nextButton.classList.add(clsx(styles.paramsExpandButtonRotate));
      }
      // сокрытие или раскрытие записей в зависимости от условия
      if (condition) {
        nextRec.classList.remove(clsx(styles.hiddenBlock));
        const td = nextRec.querySelector(".td-name");
        if (td && tdName) td.style.width = tdName.style.width;
      } else {
        nextRec.classList.add(clsx(styles.hiddenBlock));
      }
      // проверка привязки к родительской записи
      if (
        nextRec.dataset.level !== `${Number(level) + 1}` ||
        Number(nextRec.dataset.options) & ParamSetOption.Disabled
        // Number(nextRec.dataset.options) & ParamSetOption_Hidden
      ) {
        nextRec.classList.add(clsx(styles.hiddenBlock));
      }
      nextRec = nextRec.nextElementSibling;
    }

    // поворот кнопки при сворачивании
    if (condition) button.classList.remove(clsx(styles.paramsExpandButtonRotate));
    else button.classList.add(clsx(styles.paramsExpandButtonRotate));
    record.dataset.collapsed = condition ? "0" : "1";
  }

  // функция на редактирование параметров
  async function onEdit(data) {
    const textValueDiv = data.record.querySelector('[textvalue="true"]');
    // если нет изменений значения или id, или состояния чекбокса, то устанавливается старое
    if (data.value === undefined) data.value = data.record.dataset.value;
    if (data.tag === undefined) data.tag = data.record.dataset.objref;

    mouseDown.current = false;
    if (data.value !== undefined) textValueDiv.innerText = data.value;

    // получение запроса для редактирования и ответа

    if (data.proof === true && data.type !== undefined && data.value !== "") {
      const params = {
        Flag: "-1",
        ObjType: data.datatype,
        ObjRef: data.ObjRef || "0",
        Text: data.value || "",
      };
      const config = {
        prefix: data.type,
        method: "GET",
        url: "SetObjectText",
        params,
      };

      const json = await smetaAxios(config);

      data.editType = "ObjRef";
      data.proof = false;

      settingValues(
        {
          Selection: json.Selection,
          Token: json.Token,
          CreateNew: json.Selection ? undefined : json.CreateNew,
          ObjRef: json.ObjRef,
          Text: json.Text,
          EditVal: json.Text,
          noUpdate: true,
        },
        data,
      );

      if (!json.Token && !json.CreateNew && json.Selection.length === 0) {
        await getSetParamRequest(
          props.onEditCustom ? "custom" : undefined,
          props,
        )({
          ID: data.record.id.split("_")[1],
          ObjRef: data.tag,
          Value: data.value,
          CheckState: data.CheckState || data.record.dataset.checkstate,
          Type: "Text",
          ObjType: data.datatype,
          TextChanged: data.textchanged,
        }).then((res) => {
          // Установка значений параметров
          settingValues(res, data);
        });
      }

      return;
    }

    if (data.value === "") {
      data.tag = 0;
      data.record.dataset.value = "";
      data.record.dataset.tag = "0";
    }

    await getSetParamRequest(
      props.onEditCustom ? "custom" : undefined,
      props,
    )({
      ID: data.record.id.split("_")[1],
      ObjRef: data.tag,
      Value: data.value,
      CheckState: data.CheckState || data.record.dataset.checkstate,
      Type: data.editType || (data.CheckState ? "State" : "ObjRef"),
      fieldname: data.fieldname,
      ObjType: data.datatype,
      TextChanged: data.textchanged,
    }).then((res) => {
      // Установка значений параметров
      settingValues(res, data);
    });
  }

  // функция установки локальных значений параметров
  async function settingValues(res, data) {
    props.valueChanged.current = true;

    // при наличии Токена установка идет через токен процесс
    if (res) {
      if (res.Token) {
        tokenProcessingTest(res, {
          func: (val) => {
            settingValues(val, data);
          },
        });
        return;
      }

      // открытие окна с выбором элементов при неточном вводе в ручную
      if (res.Selection && res.Selection.length) {
        smetaModals.open(<DialogSetObjText list={res.Selection} onEdit={onEdit} record={data.record} data={data} />, {
          Title: "Выберите элемент из списка",
          style: getStyleWindow(),
          blockMaximize: true,
        });
        return;
      }

      // открытие окна с созданием нового объекта
      if (res.CreateNew) {
        smetaModals.open(
          <DialogCreateObj
            onEdit={onEdit}
            inputNameObj={res.CreateNew.Text}
            spanText={res.CreateNew.Label}
            CLSID={res.CreateNew.CLSID}
            ObjType={data.datatype}
            Module={data.type}
            groups={res.CreateNew.Groups}
            record={data.record}
          />,
          {
            Title: "Создать новый объект",
            style: getStyleWindow(`${res.CreateNew.CLSID}${res.CreateNew.Groups ? "Group" : ""}`),
            hiddenButton: true,
            blockMaximize: true,
            blockSaveLocation: true,
          },
        );
        return;
      }

      // обновление значений из ответа
      // редактируемая запись
      const rec = data.record;
      // контейнер со значением параметра
      const textValueDiv = rec.querySelector('[textvalue="true"]');
      const editText = res.EditVal || res.Text || "";
      const text = res.Text || res.EditVal || "";

      editorVals.current[rec.dataset.name] = editText;

      const resultText = Object.values(editorVals.current)
        .filter((item) => {
          if (item) return item;
        })
        .join(";");

      props.setParentEditorValue({
        label: resultText,
      });
      props.setParentEditorValueInput(resultText);

      if (data.CheckState !== 0) {
        // заполнение записи данными
        rec.dataset.editval = editText;
        rec.dataset.value = text;
        rec.dataset.objref = res.ObjRef
          ? res.ObjRef
          : data.record.dataset.objref !== undefined
            ? data.record.dataset.objref
            : "0";
        textValueDiv.innerText = text;

        textValueDiv.style.color =
          textValueDiv.innerText < 0 && rec.dataset.options & ParamSetOption.RedNegative
            ? "red"
            : setColor(res.TextColor);

        // обновление значения в редакторе
        if (editor.current) {
          const edition = editionMap.get(rec.id);
          if (edition) {
            edition.setValue({
              label: editText,
              id: res.ObjRef ? res.ObjRef : "0",
            });
            edition.setInputValue(editText);
          }
        }
      } else {
        rec.dataset.editval = "";
        rec.dataset.value = "";
        rec.dataset.objref = "0";
        textValueDiv.innerText = "";
        if (editor.current) {
          const edition = editionMap.get(rec.id);
          if (edition) {
            edition.setValue({
              label: "",
              id: "0",
            });
            edition.setInputValue("");
          }
        }
      }
    }
  }

  // функция открытия модального окна в редакторе
  async function onEditButtonClick(data) {
    if (props.onEdit) {
      const params = {
        DocCfgID: props.DocCfgID,
        DocID: data.subData.props.record.id.split("_")[1],
        Type: "EditRef",
        WSM: "1",
      };
      const config = {
        prefix: Prefixes.doc,
        method: "GET",
        url: "ExecDetailHandler",
        params,
      };
      const json = await smetaAxios(config);
      if (json) tokenProcessingTest(json, data.subData);
    } else {
      if (data.datatype <= 12 && data.datatype >= 7) {
        smetaModals.open(
          <TextAreaWithButtons
            props={{
              ...data.subData.props,
              setValue: data.setValue,
              setInputValue: data.setInputValue,
              Title: data.subData.props.record.dataset.name,
            }}
          />,
          { Title: "Текст параметра", style: getStyleWindow(), hiddenButton: true },
        );
        return;
      }

      if (data.subData.props.editParam !== undefined) {
        const params = {
          Path: props.Path || paramsData.Path,
          ID: data.subData.props.record.id.split("_")[1],
          WSM: "1",
        };
        const config = {
          prefix: Prefixes.progs,
          method: "GET",
          url: "EditParamProperty",
          params,
        };
        const json = await smetaAxios(config);
        if (json) tokenProcessingTest(json, data.subData);
      } else {
        if (data.json && Object.values(data.json).length > 2) {
          tokenProcessingTest(data.json, data.subData);
        }
      }
    }
  }

  // функция значений для выпадающего списка в редакторе
  async function onDropDownList(data, checklist) {
    if (props.onListCustom) {
      return await props.onListCustom(data);
    }
    if (props.onList) {
      const params = {
        DocCfgID: props.DocCfgID,
        DocID: data.record.id.split("_")[1],
        Type: "DropDown",
        WSM: "1",
      };
      const config = {
        prefix: Prefixes.doc,
        method: "GET",
        url: "ExecDetailHandler",
        params,
      };
      const json = await smetaAxios(config);
      if (json && json.Items) {
        return Object.values(json.Items).map((item, index) => {
          if (typeof item !== "object") {
            if (checklist) return { label: item, id: `${Math.pow(2, index)}` };
            return { label: item, id: `${index}` };
          }
          return { label: item.text, id: item.id };
        });
      }
    } else {
    }
  }

  async function onEditList(data) {
    if (props.onCloseUpListCustom) {
      const json = await props.onCloseUpListCustom({
        ...data,
        parentID: props.ID,
      });
      settingValues(json, data);
      return;
    }
  }

  // функция для рендера или сокрытия/раскрытия редактора
  function renderEditor(ev) {
    if (props.HardCodeReadOnlyForEditor === "1") return;
    // выбранная запись
    const record = ev.target.closest("TR");
    // проверка на отображение редактора
    if (!record.querySelector('div[editor="true"]').classList.contains(clsx(styles.hiddenBlock))) return;

    record.style.backgroundColor = "whitesmoke";

    // контейнер для редактора
    const editorDiv = record.querySelector('[editor="true"]');
    // контейнер для текста параметров
    const textValueDiv = record.querySelector('[textvalue="true"]');

    // удаление(скрытие) другого отрисованного редактора
    if (editor.current && editor.current !== editorDiv) {
      deleteEditor(editor.current);
    }

    const editRoot = editorDiv.root || createRoot(editorDiv);
    editorDiv.root = editRoot;
    editorDiv.classList.remove(clsx(styles.hiddenBlock));
    textValueDiv.classList.add(clsx(styles.hiddenBlock));
    // отрисовка редактора
    editRoot.render(
      <Editor
        styleInput={{ height: "20px" }}
        styleComponent={{ height: "20px" }}
        placeholder=" "
        groupid={record.dataset.groupid}
        current={record.dataset.current}
        fieldname={record.dataset.fieldname}
        name={record.dataset.name}
        type={record.dataset.module}
        record={record}
        objref={record.dataset.objref}
        value={record.dataset.editval}
        datatype={record.dataset.datatype}
        editStyle={record.dataset.editstyle}
        checkstate={record.dataset.checkstate}
        onEdit={onEdit}
        onEditButtonClick={onEditButtonClick}
        onDropDownList={onDropDownList}
        onEditList={onEditList}
        getEdition={setGetEdition}
        editParam={record.dataset.onedit}
        disabled={false}
      />,
    );

    // отрисованный редактор
    editor.current = editorDiv;

    // фокус на поле ввода
    const input = editorDiv.querySelector("input[type=text]");
    if (input) {
      input.focus();
      // проверка на readOnly
      if (record.dataset.editstyle & EditStyle.ReadOnly) return;
      input.select();
    }
  }

  // функция скрытия редактора и отображения текста параметров
  function deleteEditor(editor) {
    if (!editor?.classList) return;
    if (!editor.classList.contains(clsx(styles.hiddenBlock))) {
      const record = editor.closest("TR");
      record.style.backgroundColor = "";
      const textValueDiv = record.querySelector('[textvalue="true"]');
      editor.classList.add(clsx(styles.hiddenBlock));
      textValueDiv.classList.remove(clsx(styles.hiddenBlock));
    }
  }

  // функция на нажатие стрелок
  // проверяет следующий элемент на отображение и рисует в нем редактор
  function onKeyArrow(ev) {
    let record;
    switch (ev.key) {
      case "ArrowDown":
        record = ev.target.closest("TR").nextElementSibling;
        if (record) {
          if (record.classList.contains(clsx(styles.hiddenBlock))) {
            while (record !== null) {
              record = record.nextElementSibling;
              if (record && !record.classList.contains(clsx(styles.hiddenBlock))) {
                renderEditor({ target: record });
                break;
              }
            }
          } else {
            renderEditor({ target: record });
          }
        }

        break;
      case "ArrowUp":
        record = ev.target.closest("TR").previousElementSibling;
        if (record) {
          if (record.classList.contains(clsx(styles.hiddenBlock))) {
            while (record !== null) {
              record = record.previousElementSibling;
              if (record && !record.classList.contains(clsx(styles.hiddenBlock))) {
                renderEditor({ target: record });
                break;
              }
            }
          } else {
            renderEditor({ target: record });
          }
        }
        break;
      default:
        break;
    }
  }

  // функция установки размеров блока с кнопками
  function getButtonColWidth(options, other) {
    let res = 0;
    if (options & ParamSetOption.History) {
      res += 20;
    }
    return res;
  }

  const historyButtonClick = (item, index) => {
    const paramsRequest = new Map();
    paramsRequest
      .set("prefix", "programs")
      .set("Path", props.Path ? props.Path : paramsData.Path)
      .set("ID", item.ID);
    smetaModals.open(
      <DialogHistory
        paramsRequest={paramsRequest}
        Module={item.Module}
        EditStyle={item.EditStyle}
        DataType={item.DataType}
        Options={item.Options}
        Values={item.Values}
        onSelect={(json) => {
          settingValues(
            { Values: [json.CheckState === undefined ? { ...json, CheckState: "0" } : json] },
            {
              record: paramsBox.current.querySelector(`#param_${item.ID}_${index}`),
            },
          );
        }}
      />,
      {
        Title: item.Name,
        style: getStyleWindow(),
        blockMaximize: true,
        blockSaveLocation: true,
      },
    );
  };

  // Функция отрисовки записей для таблицы параметров
  function getJsxParams(items) {
    let colWidth;
    const returnArr = items.map((item, index) => {
      editorVals.current[item.Title ? item.Title : item.Name] = item.EditVal;
      const expandButton = getExpandButton(items, item, index);
      // условие для отрисовки чекбокса отдельно
      const editStyle = item.EditStyle & 4 ? item.EditStyle - 4 : item.EditStyle;

      colWidth = getButtonColWidth(item.Options);
      if (buttonBlockWidth < colWidth) {
        setbuttonBlockWidth(colWidth);
      }
      let accText;
      if (props.AccDetails && item.ObjRef) {
        accText = inputValue.current.shift();
      }

      return (
        <tr
          // данные параметра хранятся внутри записи
          id={`param-key_${item.ID}_${index}`}
          key={`param-key_${item.ID}_${index}`}
          data-datatype={item.ObjType}
          data-editstyle={editStyle}
          data-fieldname={item.FieldName ? item.FieldName : item.Name}
          data-name={item.Title ? item.Title : item.Name}
          data-mapid={item.MapID}
          data-module={item.Module}
          data-options={item.Options}
          data-orderno={item.OrderNo}
          data-shortname={item.ShortName}
          data-level={item.Level ? item.Level : 0}
          data-parentid={item.ParentID}
          data-collapsed={(Number(item.Options) & ParamSetOption.Collapsed) === ParamSetOption.Collapsed ? "1" : "0"}
          data-value={accText ? accText : item.Text}
          data-editval={item.EditVal !== undefined ? item.EditVal : item.Value}
          data-objref={item.ObjRef}
          data-groupid={paramsData.GroupID}
          data-current={item.Current}
          data-checkstate={item.EditStyle & 4 && item.ObjRef === "1" ? "1" : item.CheckState}
          data-onedit={item.OnEdit}
          onMouseEnter={(ev) => {
            if (mouseDown) {
              if (mouseDown.current) renderEditor(ev);
            }
          }}
          onClick={(ev) => {
            renderEditor(ev);
          }}
          onKeyDown={(ev) => {
            onKeyArrow(ev);
          }}
          className={clsx(
            styles.paramsRecord,
            ((item.Level && item.Level !== "0") ||
              Number(item.Options) & ParamSetOption.Disabled ||
              Number(item.Options) & ParamSetOption.Hidden) &&
              styles.hiddenBlock,
          )}
        >
          {/* Имя параметра */}
          <td
            id={`name_${item.ID}`}
            title={item.Name}
            className={clsx(styles.paramsName, "td-name")}
            style={{
              paddingLeft: getPadding(items, item, index),
              width: `${width}%`,
            }}
          >
            {expandButton}
            <span style={getStyleName(item)}>{item.Title ? item.Title : item.Name}</span>
            {/* Колонка для кнопок история, выражение и тд */}
            <div
              className={clsx(styles.paramsConditions)}
              style={{
                width: getButtonColWidth(item.Options, {
                  Conditions: item.Conditions,
                }),
              }}
            >
              <IconButton
                onClick={() => historyButtonClick(item, index)}
                className={clsx(
                  styles.paramsHistoryButton,
                  (item.Options & ParamSetOption.History) === 0 && styles.hiddenBlock,
                )}
              >
                <HistoryIcon style={{ height: "15px", width: "15px" }} />
              </IconButton>
              <ConditionButton
                visible={item.Conditions ? true : false}
                conditions={item.Conditions}
                condition={item.Condition ? item.Condition : "1"}
                onEdit={onEdit}
                recID={`param_${item.ID}_${index}`}
                paramsBoxRef={paramsBox}
              />
            </div>
          </td>
          {/* Разделитель */}
          <td onMouseDown={onMouseDown} className={clsx(styles.paramsSplitter)} id="splitter-ID">
            <br></br>
          </td>
          {/* Значение параметра */}
          <td id={`value_${item.ID}`} className={styles.paramsValueConteiner}>
            <div className={clsx(styles.paramsCheckContainer, (item.EditStyle & 4) === 0 && styles.hiddenBlock)}>
              {/* чекбокс с множеством состояний */}
              <CheckBoxMultiCheck onEdit={onEdit} MultiCheckSet={item.MultiCheckSet} CheckState={item.CheckState} />
            </div>
            {/* текстовое значение параметра */}
            <div
              className={clsx(styles.paramsValue)}
              style={{
                color: item.Text < 0 && item.Options & ParamSetOption.RedNegative ? "red" : setColor(item.TextColor),
                ...getStyleText(item),
              }}
              textvalue={"true"}
            >
              {accText ? accText : item.Text}
            </div>

            {/* контейнер для редактора */}
            <div className={clsx(styles.paramsEditorContainer, styles.hiddenBlock)} editor={"true"}></div>
          </td>
        </tr>
      );
    });

    return returnArr;
  }

  return (
    <ClickAwayListener
      onClickAway={(ev) => {
        mouseDown.current = false;
        resize = {};
        if (
          ev.target.closest("[checklist]") ||
          ev.target.closest("[calendar]") ||
          (ev.target.closest(".background_ModalDialog") &&
            ev.target.closest(".background_ModalDialog") !== paramsBox.current.closest(".background_ModalDialog")) ||
          ev.target.closest("LI")
        ) {
          return;
        }
        if (editor.current) {
          editor.current.closest("TR").style.backgroundColor = "";
          deleteEditor(editor.current);
        }
      }}
    >
      <div
        ref={paramsBox}
        onMouseDown={(ev) => {
          mouseDown.current = true;
        }}
        onMouseUp={() => {
          mouseDown.current = false;
        }}
        className={clsx(styles.paramsBox)}
      >
        <div style={{ display: props.NoTitle ? "none" : "", height: "30px" }}>
          <span>{title}</span>
        </div>
        <div className={clsx(styles.paramsTableContainer)}>
          {paramsJsx ? (
            <div
              onMouseMove={onMouseMove}
              onMouseUp={(ev) => onMouseUp(ev, setWidth)}
              className={clsx(styles.paramsTable)}
            >
              <tbody>{paramsJsx}</tbody>
            </div>
          ) : (
            <LoadingMask />
          )}
        </div>
      </div>
    </ClickAwayListener>
  );
}
